import styles from "./CustomLoader.module.scss";

function CustomLoader(props) {
  return (
    <div className={styles["prebook-loader-overlay"]}>
      <div className={styles["loader-container"]}>
        <div className={styles["loader-spinner"]}></div>
      </div>
    </div>
  );
}

export default CustomLoader;
